import { Reducer, AnyAction } from "@myvp/shared/src/types"

export const reduceReducers =
  (...reducers: Reducer[]): Reducer =>
  <State>(state: State, action: AnyAction): State =>
    reducers.reduce(
      (acc: State, nextReducer: Reducer) => nextReducer(acc, action),
      state
    )
